// GENERATED by scripts/gen-look.py from vendor-ref/nanome@868d90f: Assets/Scripts/src/Nanome.Adapter/Display/SecondaryStructureColors.cs (Default) + Nanome.Domain/Model/Properties/SecondaryStructure.cs
// Do not edit by hand.

/** Enum values follow SecondaryStructure.cs: NotAssigned=-1, Loop=0, Turn, AlphaHelix, Strand, BetaBridge, Helix3, Helix5, Bend, Nucleic_* */
export const SS_COLORS: Readonly<Record<string, number>> = {
  NotAssigned: 0xFFFFFF,
  Loop: 0xFFFFFF,
  Turn: 0x00B266,
  AlphaHelix: 0xFF0080,
  Strand: 0xFFC800,
  BetaBridge: 0x6080FF,
  Helix3: 0xA00080,
  Helix5: 0x600080,
  Bend: 0x66D8C9,
  Nucleic_Single: 0xAE00FE,
  Nucleic_Double: 0xAE00FE,
  Nucleic_Helix: 0xAE00FE,
  Nucleic_StemLoop: 0xAE00FE,
  Nucleic_PseudoKnot: 0xAE00FE,
  Nucleic_Bulge: 0xAE00FE,
  Nucleic_HairpinLoop: 0xAE00FE,
  Nucleic_InternalLoop: 0xAE00FE,
  Nucleic_MultiLoop: 0xAE00FE,
};
